(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintHollowingView} controller
   * @param {Viewer} viewer
   * @param {Design} design
   */

  var _this;

  var PrintHollowingView = (scope.PrintHollowingView = function (
    controller,
    viewer,
    design,
    material,
    optionsTools
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewer.viewerUI;
    this.viewer = viewer.viewerUI.viewer;
    this.material = material;
    this.optionsTools = optionsTools;

    this.isDone = false;

    this.is_hollowed = false;

    // used for the message to remind the user to use Hollowing
    this.unitPriceMinimum = 200 * 100; // 200.00€/$ but it is stored as 20000
    this.densityMinimum = 0.3;

    //we need hollowingUI for hollowing to work
    this.hollowingUI = null;

    this.hollowing_prevent_save = false;

    this.hollow_mat_dfd = $.Deferred();
    this.hollow_mat_dfd.resolve();

    this.$el = $("#hollowing-settings");

    this.$el.on(
      "click",
      ".tool-back-default",
      this.backToDefaultView.bind(this)
    );
    this.$el.on("click", ".tool-reset", this.reset.bind(this));
    this.$el.on("click", ".tool-start", this.clickStart.bind(this));
    this.$el.on("click", ".tool-edit", this.editHollowing.bind(this));
    this.$el.on("click", ".tool-done", this.saveHollowing.bind(this));

    this.step_start();

    _this = this;
  });

  // will display a message based on the unit price and density
  // The message purpose is a reminder to use Hollowing to reduce the cost of the design
  PrintHollowingView.prototype.toggleOptimizeMessageForHollowing = function (
    unit_price,
    density
  ) {
    // don't show the message if it's already hollowed
    if (
      this.is_hollowed ||
      !sculpteo.TOOL_AVAILABLE_MAP.HOLLOWING.test(
        this.controller.materials.getCurrentMaterialMap()
      )
    )
      return;

    if (
      !this.design.is_medical &&
      unit_price >= this.unitPriceMinimum &&
      density > this.densityMinimum
    ) {
      // display the message
      this.controller.notify(
        "info",
        sculpteo.INFO.HOLLOWING_PURPOSE,
        false,
        null
      );
    }
  };

  PrintHollowingView.prototype.has_hollowing = function () {
    if (this.design.get_operation("HollowDesignOperation")) {
      this.isDone = true;
      this.is_hollowed = true;
      var opts = this.getOpts();

      this.mainHollowing(opts, 4);
      this.step_savedButton();

      this.controller.views.tools.setEnabled(
        sculpteo.PrintToolsView.TOOLS.HOLLOWING,
        true
      );
    }
  };

  /**
   * get new opts
   * @public
   */
  PrintHollowingView.prototype.getOpts = function () {
    var opts = {
      hole_update_type: 1,
      thickness_slider: "#StaffHollowing #Controls #Offset .the-slider",
      step_slider: "#StaffHollowing #Controls #Step .the-slider",
      hole_width_slider: "#StaffHollowing #Controls #Width .the-slider",
      hole_depth_slider: "#StaffHollowing #Controls #Depth .the-slider",
      add_hole_button: $(".tool-add-more-hole"),
      delete_last_hole_button: $(".tool-undo"),
      reset_button: $(".tool-reset"),
      create_holes_button: $(".tool-done"),
      on_wall_change: this.on_hollow_update_price,
      on_add_hole: this.on_add_hole,
      on_add_hole_done: this.on_add_hole_done,
      on_update_hole: this.on_hollow_update_price,
      on_delete_hole: this.on_delete_hole,
      on_deinit: this.on_deinit,
      on_fatal_error: this.on_fatal_error,
    };

    return opts;
  };

  /**
   * enable hollowing
   * @public
   */
  PrintHollowingView.prototype.enabled = function () {
    this.$el.show();
  };

  /**
   * disable hollowing
   * @public
   */
  PrintHollowingView.prototype.disabled = function () {
    this.$el.hide();

    if (!this.isDone) this.reset();
  };

  /**
   * Back to default view
   * @private
   */
  PrintHollowingView.prototype.backToDefaultView = function (e) {
    if (!this.isDone) this.reset();

    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };

  /**
   * click on button start
   * @private
   */
  PrintHollowingView.prototype.clickStart = function (e) {
    var opts = this.getOpts();

    //0 start hollowing
    this.mainHollowing(opts, 0);
  };

  /**
   * reset hollowing
   * @private
   */
  PrintHollowingView.prototype.reset = function (e) {
    //if hollowing have not been start we do not reset
    if (!this.is_hollowed) return;

    this.removeHollowing();

    this.step_start();

    this.isDone = false;
    this.is_hollowed = false;
  };

  /**
   *use when we want to edit the current hollowing
   * @private
   */
  PrintHollowingView.prototype.editHollowing = function () {
    var opts = this.getOpts();

    // 1 edit hollowing
    this.mainHollowing(opts, 1);
  };

  /**
   * save hollowing
   * @private
   */
  PrintHollowingView.prototype.saveHollowing = function (e) {
    this.isDone = true;

    this.step_savedButton();

    this.controller.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.INFO,
      gettext("Your model hollowed have been saved"),
      false
    );

    this.controller.views.tools.setEnabled(
      sculpteo.PrintToolsView.TOOLS.HOLLOWING,
      true
    );
  };

  /**
   * scale updated
   * @public
   */
  PrintHollowingView.prototype.scaleUpdated = function () {
    if (!this.isDone) return;
    this.update_hollow_scale();
  };

  /**
   * unit updated
   * @public
   */
  PrintHollowingView.prototype.unitUpdated = function () {
    if (!this.isDone) return;
    this.update_hollow_scale();
  };

  /**
   * materials updated
   * @public
   */
  PrintHollowingView.prototype.materialUpdated = function () {
    if (!this.isDone) return;
    this.update_hollow_scale();
  };

  PrintHollowingView.prototype.step_start = function () {
    $(".tool-reset", this.$el).hide();
    $(".tool-start", this.$el).show();
    $(".tool-undo", this.$el).hide();
    $(".tool-add-more-hole", this.$el).hide();
    $(".tool-done", this.$el).hide();
    $(".tool-edit", this.$el).hide();
  };

  PrintHollowingView.prototype.step_firstHoleButton = function () {
    $(".tool-reset", this.$el).show();
    $(".tool-start", this.$el).hide();
    $(".tool-undo", this.$el).show();
    $(".tool-done", this.$el).hide();
    $(".tool-add-more-hole", this.$el).hide();
    $(".tool-edit", this.$el).hide();
  };

  PrintHollowingView.prototype.step_secondHoleButton = function () {
    $(".tool-reset", this.$el).show();
    $(".tool-start", this.$el).hide();
    $(".tool-undo", this.$el).show();
    $(".tool-add-more-hole", this.$el).hide();
    $(".tool-edit", this.$el).hide();
  };

  PrintHollowingView.prototype.step_moreHoleButton = function () {
    $(".tool-reset", this.$el).show();
    $(".tool-start", this.$el).hide();
    $(".tool-undo", this.$el).show();
    $(".tool-add-more-hole", this.$el).show();
    $(".tool-done", this.$el).show();
    $(".tool-edit", this.$el).hide();
  };

  PrintHollowingView.prototype.step_savedButton = function () {
    $(".tool-reset", this.$el).show();
    $(".tool-start", this.$el).hide();
    $(".tool-undo", this.$el).hide();
    $(".tool-add-more-hole", this.$el).hide();
    $(".tool-done", this.$el).hide();
    $(".tool-edit", this.$el).show();

    $("#StaffHollowing").hide();
  };

  /**
   * @param attr Valid values:
   *          0 - Start hollowing
   *          1 - Edit hollowing
   *          2 - Remove hollowing
   *          3 - Restart hollowing
   *          4 - Init only UI components
   */
  PrintHollowingView.prototype.mainHollowing = function (opts, attr) {
    this.hollowingUI = new HollowingUI(
      this.optionsTools["hollowing-initial"].hollow_id,
      this.optionsTools["hollowing-initial"].script_id,
      this.optionsTools["hollowing-initial"].text_id,
      this.optionsTools["hollowing-initial"].hollow_script,
      this.optionsTools["hollowing-initial"].scale_limit
    );

    if (attr == 2) {
      opts.remove_holes = true;
    }

    //when loading a new page where the model is already hollowed. We just need to init hollowing
    if (attr == 4) {
      opts.init_only_ui = true;
      this.hollowingUI.initUI(this.viewerUI.viewer, this.design, opts);

      var hollow_op = null;

      var d = [this.design];
      if (this.design.partitioning) {
        d = this.design.partitioning.parts;
      }

      for (var i in d) {
        if (d.hasOwnProperty(i)) {
          var op = d[i].get_operation("HollowDesignOperation");

          if (op) {
            hollow_op = op;
          }
        }
      }

      if (hollow_op) {
        if (!hollow_op.data.enabled) {
          this.controller.overlayNotify(
            sculpteo.PrintOverlayNotification.TYPE.INFO,
            gettext("Hollowing has been disabled"),
            false
          );
        }
      }

      this.on_hollow_success();

      return false;
    }

    switch (attr) {
      case 0:
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Hollowing your model (this could take a minute)"),
          false
        );
        break;
      case 1:
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Loading hollowed model"),
          false
        );
        break;
      case 2:
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Going back to original"),
          false
        );
        break;
      case 3:
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Loading hollowed model"),
          false
        );
        break;
      case 4:
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Loading hollowed model"),
          false
        );
        break;
    }

    this.hollowingUI.initUI(this.viewerUI.viewer, this.design, opts).then(
      function () {
        if (!this.hollowingUI) {
          return false;
        }

        if (attr == 3 && this.hollowingUI.holeCount > 0) {
          this.controller.overlayNotify(
            sculpteo.PrintOverlayNotification.TYPE.INFO,
            gettext("Removing holes"),
            false
          );
          this.hollowingUI.remove_all_holes();
        }

        if (!attr || attr == 1 || attr == 3) {
          $("#StaffHollowing").show();

          this.updatePreventSave();
          this.updateNotificationWarnings();

          this.is_hollowed = true;

          if (this.hollowingUI.holeCount === 0) {
            this.hollowingUI.start_add_hole();
            this.controller.overlayNotify(
              sculpteo.PrintOverlayNotification.TYPE.INFO,
              gettext("Done! Click to add holes"),
              false
            );
          } else if (this.hollowing_prevent_save) {
            this.hollowingSecondHole();
          } else {
            this.hollowingDone();
          }
        } else {
          this.hollowingUI.deinitUI();
          this.on_hollow_abort();
          this.on_hollow_update_price();
        }
      }.bind(this)
    );
  };

  /**
   * method called when we're about to add the second holes
   * @private
   */
  PrintHollowingView.prototype.hollowingSecondHole = function () {
    this.hollowingUI.start_add_hole();
    this.step_secondHoleButton();

    $.when(this.hollow_mat_dfd).then(
      function () {
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Add the second hole"),
          false
        );
      }.bind(this)
    );
  };

  /**
   * method called when we're about to add more holes
   * @private
   */
  PrintHollowingView.prototype.hollowingDone = function () {
    this.step_moreHoleButton();

    $.when(this.hollow_mat_dfd).then(
      function () {
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Add More holes or finish up"),
          false
        );
      }.bind(this)
    );
  };

  /**
   * Update hollowing when the scale/unit/material changed
   * @private
   * TODO  fix issue
   */
  PrintHollowingView.prototype.update_hollow_scale = function () {
    var dfd = true;

    if (this.hollowingUI) {
      dfd = $.Deferred();

      this.hollowingUI.enableUIComponents(false);

      this.hollowingUI.create_holes().then(
        function () {
          this.hollowingUI.deinitUI();

          dfd.resolve();
        }.bind(this)
      );
    }

    $.when(dfd).then(
      function () {
        var op = this.design.get_operation("HollowDesignOperation");
        if (op) {
          var opts = {
            update_scale: true,
            update_material: this.material,
            onModification: function (is_hollowing, msg) {
              if (is_hollowing) {
                _this.controller.views.toolbar.notify(
                  gettext("Hollowing your model (this could take a minute)")
                );
              } else {
                _this.controller.views.toolbar.notify(
                  gettext("Going back to original")
                );
              }
            },
          };

          this.hollowingui = new HollowingUI(
            this.optionsTools["hollowing-initial"].hollow_id,
            this.optionsTools["hollowing-initial"].script_id,
            this.optionsTools["hollowing-initial"].text_id,
            this.optionsTools["hollowing-initial"].hollow_script,
            this.optionsTools["hollowing-initial"].scale_limit
          );

          this.hollowingUI.initUI(this.viewer, this.design, opts).then(
            function (hollow_active) {
              this.hollowingui = null;
            }.bind(this)
          );
        } else if (this.material) {
          var parts = [this.design];
          var limit_scale = 0;
          var disabled = 0;

          if (this.design.partitioning) {
            parts = this.design.partitioning.parts;
          } else if (this.design.parent) {
            parts = this.design.parent.partitioning.parts;
          }

          for (var i = 0; i < parts.length; ++i) {
            if (
              !this.material.hole_threshold ||
              !this.material.wall_thickness ||
              this.design.order.finish == "myrtillage" ||
              this.design.order.finish == "chemical_smoothing"
            ) {
              disabled++;
            } else {
              if (this.hollowingUI.scale_limit) {
                var scale_limit = this.hollowingUI.scale_limit;
                var scaleFactor =
                  this.design.size.userScale *
                  this.design.size.units[this.design.size.unit];
                var wall =
                  (this.material.wall_thickness * this.design.size.units.mm) /
                  scaleFactor;

                if (
                  wall * scale_limit > this.design.size.x ||
                  wall * scale_limit > this.design.size.y ||
                  wall * scale_limit > this.design.size.z
                ) {
                  limit_scale++;
                }
              }
            }
          }

          if (disabled == parts.length) {
            this.controller.views.toolbar.notify(gettext("hollowing_disabled"));
          } else if (limit_scale == parts.length) {
            this.controller.views.toolbar.notify(
              gettext("hollowing_design_too_small")
            );
          } else if (disabled + limit_scale == parts.length) {
            this.controller.views.toolbar.notify(
              gettext("All parts could not be hollowed")
            );
          } else if (disabled || limit_scale) {
            this.controller.views.toolbar.notify(
              gettext("Some parts could not be hollowed")
            );
          } else {
          }
        }
      }.bind(this)
    );
  };

  /**
   * method called when there is warning, update notification view when there is some warning
   * @private
   */
  PrintHollowingView.prototype.updatePreventSave = function () {
    this.hollowing_prevent_save = false;
    this.hollowing_prevent_save = this.hollowingUI.have_one_hole > 0;
  };

  /**
   * update notification warnings
   * @private
   */
  PrintHollowingView.prototype.updateNotificationWarnings = function () {
    var warnings = [];
    for (var i = 0; i < this.hollowingUI.design_warnings.length; ++i) {
      this.controller.notify(
        "warn",
        _this.hollowingUI.design_warnings[i].id,
        false
      );
      warnings.push(this.hollowingUI.design_warnings[i].id);
    }
  };

  /**
   * update price when there is at least 1 hole
   * @private
   */
  PrintHollowingView.prototype.on_hollow_update_price = function () {
    var _this = this;
    _this.controller.updatePriceForSelectedMaterial().then(function () {
      _this.updateNotificationWarnings();
    });
  };

  /**
   * called when hollowing is ok
   * @private
   */
  PrintHollowingView.prototype.on_hollow_success = function () {
    $(".tool-edit", this.$el).show();
  };

  /**
   * called when hollowing is aborted
   * @private
   */
  PrintHollowingView.prototype.on_hollow_abort = function () {
    $("#StaffHollowing").hide();
  };

  /**
   * called when a hole is done
   * @private
   */
  PrintHollowingView.prototype.on_add_hole_done = function () {
    if (!_this.hollowingUI) {
      return;
    }

    _this.on_hollow_update_price();

    _this.updatePreventSave();

    if (_this.hollowingUI.holeCount == 1) {
      _this.step_firstHoleButton();
      _this.hollowingSecondHole();
    } else if (!_this.hollowing_prevent_save) {
      _this.hollowingDone();
    } else {
      _this.hollowingSecondHole();
      $.when(_this.hollow_mat_dfd).then(function () {
        _this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Add another hole"),
          false
        );
      });
    }
  };

  /**
   * called when hole is going to be added
   * @private
   */
  PrintHollowingView.prototype.on_add_hole = function (design) {
    _this.controller.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.INFO,
      gettext("Adding hole..."),
      false
    );
    _this.hollowingUI.finish_add_hole(design);
  };

  /**
   * called when a hole is deleted
   * @private
   */
  PrintHollowingView.prototype.on_delete_hole = function () {
    if (!_this.hollowingUI) {
      return;
    }

    _this.on_hollow_update_price();
    _this.updatePreventSave();

    var opts = _this.getOpts();

    if (_this.hollowingUI.holeCount === 1) {
      _this.step_firstHoleButton();
      _this.mainHollowing(opts);
    } else if (_this.hollowingUI.holeCount === 0) {
      _this.mainHollowing(opts);
    } else if (!_this.hollowing_prevent_save) {
      _this.hollowingDone();
    } else {
      _this.hollowingSecondHole();
      $.when(_this.hollow_mat_dfd).then(function () {
        _this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.INFO,
          gettext("Add another hole"),
          false
        );
      });
    }
  };

  /**
   * call when we remove hollowing
   * @private
   */
  PrintHollowingView.prototype.on_deinit = function () {};

  /**
   * when there is a BIG error
   * @private
   */
  PrintHollowingView.prototype.on_fatal_error = function (msg) {
    _this.controller.notify("warn", msg.id, false);
    _this.removeHollowing().then(function () {
      _this.isDone = false;
    });
    this.is_hollowed = false;
  };

  /**
   *
   * remove all hollowing
   * @private
   */
  PrintHollowingView.prototype.removeHollowing = function () {
    var dfd = $.Deferred();

    this.controller.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.INFO,
      gettext("Going back to original"),
      false
    );
    this.hollowingUI.enableUIComponents(false);

    if (this.design.hollowing) {
      this.hollowingUI.abort_ops().then(
        function () {
          this.hollowingUI.remove_hollowing_and_deinit().then(
            function () {
              this.on_hollow_abort();
              this.on_hollow_update_price();
              this.controller.views.tools.setEnabled(
                sculpteo.PrintToolsView.TOOLS.HOLLOWING,
                false
              );

              dfd.resolve();
            }.bind(this)
          );
        }.bind(this)
      );
    } else {
      var opts = this.getOpts();
      this.mainHollowing(opts, 2);
      this.controller.views.tools.setEnabled(
        sculpteo.PrintToolsView.TOOLS.HOLLOWING,
        false
      );
    }

    return dfd.promise();
  };
})((window.sculpteo = window.sculpteo || {}));
